module.exports = __webpack_public_path__ + "img/IMG_5902.4bff1599.jpg";